import { z } from 'zod';
import { MediaVariantsSchema } from './media-variants.js';
/**
 * Imagen lista para dibujar, con las URLs **ya resueltas** por la API.
 *
 * `variants: null` = media subida antes del worker de recortes: el sitio usa `url` original con
 * `aspect-ratio` por CSS. Es fallback contractual, no error. `url: null` = el almacenamiento no
 * tiene base pública configurada (disco local, y los tests).
 *
 * Vive en su propio módulo y no en `public-site.ts` porque también la usa el cuerpo de la nota
 * (`article-body.ts`), y ese archivo no puede depender de los contratos del sitio sin cerrar un
 * ciclo de imports.
 */
export const PublicImage = z
    .object({
    url: z.string().nullable(),
    /** El producto exige alt para publicar: en notas publicadas nunca está vacío. */
    alt: z.string().nullable(),
    width: z.number().int().nullable(),
    height: z.number().int().nullable(),
    variants: MediaVariantsSchema.nullable(),
})
    .strict();
